export default {
  initIndicatorList: {},
  visitedBdList: [],
  visitedListData: {
    total: 0,
    list: [],
  },
  selectVisitedList: [],
  accompanyingBD: {
    fullName: '',
    username: '',
  }, // 被陪访人
  accompanyForm: {
    visitBefore: [],
    visitBeforeScore: 0,
    visiting: [],
    visitingScore: [],
    visitAfter: [],
    visitAfterScore: [],
    preparedForVisit: '', // version3: 拜访前-准备工作
    dateValue: '', // 拜访时间
    visitedBdUsername: '', // 被陪同人员
    relatedVisitId: [], // 关联拜访记录的门店id
    effectiveVisit: '', // 拜访前-BD进行了有效的拜访
    appReview: '', // 拜访中-app审查
    studiedTheNeedsOfMerchant: '', // 拜访中-BD列出了营销活动或研究了商家的需求
    properlyHandledObjections: '', // 拜访中-BD妥善处理了商家的异议
    listedPrevConsensusAndSolutions: '', // 拜访过程-BD列出了之前的共识、解决方案
    disadvantage: '', // 整体反馈-待改进之处
    advantage: '', // 业务反馈对话-优势
  },
}
